import { Chip, ChipProps } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type StatusChipCellValue = Union.Nullable<string>;

interface StatusChipCellProps<R extends GridValidRowModel = any> {
  value: StatusChipCellValue;
  row: R;
  color?: ChipProps['color'];
}

export const StatusChipCell = <R extends GridValidRowModel = any>({ value, color }: StatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div>
      <Chip label={value} color={color} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
